import { Team } from '../model/Team';
import { RawTeamMember, TeamMember } from '../model/TeamMember';
import { teamGroups, teamMembers } from '../config/teamConfig';
import { t } from '../../i18n';
import { localizeMember } from './localizeMember';

export const buildTeam = (groupKey: string, dynamic: RawTeamMember[], lang: 'cs' | 'en'): Team => {
  const title = t(`teams.${groupKey}.title`);
  const group = teamGroups.find((g) => g.key === groupKey)!;

  const staticMembers: TeamMember[] = group.memberKeys.map((key) => {
    const member = teamMembers.find((m) => m.key === key)!;
    return {
      photo: member.photo,
      email: member.email,
      phone: member.phone,
      name: t(`teams.${groupKey}.members.${key}.name`),
      positions: t(`teams.${groupKey}.members.${key}.positions`, { returnObjects: true }) as string[],
    };
  });

  const members = groupKey === 'mildblue' ? [...staticMembers, ...dynamic.map((m) => localizeMember(m, lang))] : staticMembers;
  return { title, teamMembers: members };
};
